<!--
<button class="btn btn-outline-secondary btn-xs" (click)="menu.toggle($event)">
  <i class="fa fa-cog dropdown-toggle" aria-hidden="true"></i>
</button>

<p-menu #menu [model]="actions" [popup]="true" appendTo="body"></p-menu>
-->
<pmenu-actions [dto]="communication" [lazy]="true" [dtoType]="'COMMUNICATION'" [items]="getMenuItems(communication)"
  [postProcessMenuActionsFn]="updateActions.bind(this)">
</pmenu-actions>